import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { MSpinner } from "components/Shared";
import QaRejectionList from "components/Homeowner/Appraisal/QaRejectionList";
import { getAppraisalQARejections } from "requests/homeowner/caseforms";

export default function QaRejections(props) {

  const [appraisalQaRejections, setAppraisalQaRejections] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  let mounted = useRef(true);


  const getRejections = () => {
    getAppraisalQARejections(props.controlNumber, setAppraisalQaRejections, setIsFetching, mounted);
  };

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    getRejections();
  }, [props.controlNumber]);

  if (isFetching) {
    return <MSpinner />;
  } else {
    return (
      <div className="qa-rejections">
        <QaRejectionList
          enabled={false}
          viewOnly={false}
          qaAppraisalRejections={appraisalQaRejections}
          onRejectionClicked={() => { }} />
      </div>
    );
  }
}

QaRejections.propTypes = {
  controlNumber: PropTypes.number.isRequired, //This is needed to get the QA rejections
};